export const ssnDigitsOnlyPattern = /^\d{9}$/;

export const ssnWithDashesPattern = /^\d{3}-\d{2}-\d{4}$/;

export const ssnDigitsOnlyIsValid = (ssn: string) => ssnDigitsOnlyPattern.test(ssn);

export const ssnWithDashesIsValid = (ssn: string) => ssnWithDashesPattern.test(ssn);

export const ssnIsValid = (ssn: string) => ssnDigitsOnlyIsValid(ssn) || ssnWithDashesIsValid(ssn);

export const stripSSNDashes = (ssn: string) => {
  if (ssnWithDashesIsValid(ssn)) {
    return ssn.replace(/-/g, "");
  }
  // not starting with valid ssn with dashes, so do nothing
  return ssn;
};

export const addSSNDashes = (ssn: string) => {
  if (ssnDigitsOnlyIsValid(ssn)) {
    return ssn.slice(0, 3) + "-" + ssn.slice(3, 5) + "-" + ssn.slice(5);
  }
  // not starting with valid digits-only ssn, so do nothing
  return ssn;
};
